import React from "react";
import { ActionMenu } from "../shared/ActionMenu";

const PredictionTable = ({
    items,
    setEditId,
    form,
    handleFilterChange,
    filterDates,
    resetFilterDate,
    filterPredictorId,
    resetFilter,
    currentItems,
    handleEdit,
    handleDelete,
}) => {
    return (
        <div className="relative w-full overflow-auto rounded-md border">
                <table className="w-full caption-bottom text-sm">
                    <thead className="[&_tr]:border-b bg-muted/50">
                        <tr>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">ID Prediction</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Predicted Direction</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Predicted % Change</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Predicted Time Frame</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Actual Direction</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Actual % Change</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Evaluated At</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Score</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Stock symbol</th>
                            <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Predictor name</th>
                            <th className="h-12 px-4 text-right align-middle font-medium text-muted-foreground">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="[&_tr:last-child]:border-0">
                        {currentItems.map((item) => (
                            <tr key={item.prediction_id} className="border-b transition-colors hover:bg-muted/50">
                                <td className="p-4 align-middle">{item.prediction_id}</td>
                                <td className="p-4 align-middle">{item.predicted_direction}</td>
                                <td className="p-4 align-middle">{item.predicted_percentage_change}</td>
                                <td className="p-4 align-middle">
                                    {item.predicted_time_frame?.days
                                        ? `${item.predicted_time_frame.days} days`
                                        : (typeof item.predicted_time_frame === 'string'
                                            ? item.predicted_time_frame
                                            : 'N/A')}
                                </td>
                                <td className="p-4 align-middle">{item.actual_direction}</td>
                                <td className="p-4 align-middle">{item.actual_percentage_change}</td>
                                <td className="p-4 align-middle">
                                    {item.evaluated_at
                                        ? new Date(item.evaluated_at).toLocaleDateString('fr-FR')
                                        : 'Date non disponible'}
                                </td>
                                <td className="p-4 align-middle">{item.score}</td>
                                <td className="p-4 align-middle">{item.stockSymbol || 'Stock non disponible'}</td>
                                <td className="p-4 align-middle">
                                    <a
                                        href={`/comment?predictor_id=${item.predictor_id}&stock_symbol=${item.stockSymbol}`}
                                        title={item.commentText}
                                        className="text-primary hover:underline"
                                    >
                                        {item.predictorName || 'Nom non disponible'}
                                    </a>
                                </td>
                                <th className="p-4 align-middle text-right">
                                    <ActionMenu
                                        onEdit={() => handleEdit(item)}
                                        onDelete={() => handleDelete(item.prediction_id)}
                                    />
                                </th>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
    );
};

export default PredictionTable;
